import { Column, Entity, PrimaryGeneratedColumn, Unique } from 'typeorm';

@Entity()
@Unique(['userId'])
export class OtpEntity {
  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  userId: number;

  @Column()
  otp: string;

  @Column({ type: 'timestamp', })
  validUntil: Date;

  @Column({ default: 0 })
  numberOfTries: number;
}
